import * as React from 'react';
import {type CanvasBodyProps} from '@packages/systems/designer/canvas';
import {OpenCanvasViewportRoot} from './OpenCanvasViewportRoot';

type OpenCanvasBodyElementProps = {
  bodyEventHandlers: CanvasBodyProps['bodyEventHandlers'];
};

export const OpenCanvasBodyElement = ({
  children,
  bodyEventHandlers,
}: React.PropsWithChildren<OpenCanvasBodyElementProps>) => {
  return (
    <body data-wf-open-canvas-body="true" {...bodyEventHandlers}>
      <OpenCanvasViewportRoot>{children}</OpenCanvasViewportRoot>
    </body>
  );
};
